<template>
    <div class="big-wrap">
        <div class="app-wrap">
            <h1 class="url">22ola.com</h1>
            <div class="Tips">
                <p class="invi-des">Convide um jogador válido e ganhe R$10</p>
                <p class="invi-des">O que seria um jogador válido?</p>
                <p class="invi-des">Jogadores que fizerem uma recarga de R$20.00 e aposta de R$25.00</p>
            </div>
            <div class="total_reward">Bônus totais: R${{reward_list.length * 10}}.00 </div>
            <!-- <div class="search-wrap">
                    <input class="input-keyword" type="text" v-model="keyword" placeholder="Consultar ID do membro">
                    <img class="simg" src="../images/home/s_a.png" alt="" >
            </div> -->
            <div  class="items" v-for="(item,index) in reward_list" v-show="index < max_show">
                <div class="title">Tempo de bônus: {{ item.createtime }}</div>
                <div class="title">Tipo de recompensa: Convide jogadores</div>
                <div class="title">ID do jogador: {{ item.transaction_id }}</div>
                <div style="margin: 5px 0;">
                    <p style="margin-top:10px">Recompensa <b class="fanshui">R${{ item.money }}</b></p>
                </div>
            </div>
            <div class="show_more" v-show="reward_list.length > 5" @click="max_show+=5">Mostre mais ⇊</div>
        </div>
        <ft></ft>
    </div>
</template>
<script>
import Fetch from "../../utils/fetch";
import ft from "../../components/ft.vue"
export default {
    name: 'app',
    data() {
        return {
            reward_list: [],
            reward_list_back:[],
            max_show:5,
            keyword:""
        };
    },
    watch: {
        keyword: function (newn, old) {
            this.reward_list = [];
            this.reward_list_back.forEach(item => {
                if (item.transaction_id.toLowerCase().search(newn.toLowerCase()) != -1) {
                    this.reward_list.push(item);
                }
            })
        },
        
    },
    mounted() {
        Fetch('/reward/yongjin', {}).then(res => {
            if (res.data) {
                this.reward_list = res.data;
                this.reward_list_back = res.data;
            }
        })
    },
    components: {
        ft
    },
    methods: {
       
        
    }

}


</script>
<style scoped>
.search-wrap {
    border: 1px solid #84A559;
    height: 1rem;
    width: 100%;
    margin: 0 auto;
    border-radius: 10px;
    margin-bottom: 0.3rem;
}

.simg {
    width: 0.5rem;
    float: right;
    margin-top: 0.2rem;
    margin-right: 0.3rem;
}

.input-keyword {
    width: 70%;
    height: 100%;
    color: #84A559;
    font-size: 0.38rem;
    float: left;
    margin-left: 20px;
}
.input-keyword::placeholder {
    color: #84A559;
}
.show_more{
    color: #84A559;
    width: 100%;
    height: 0.8rem;
    line-height: 0.8rem;
    bottom: 0;
    text-align: center;
    font-size: 0.35rem;
}
.total_reward{
    height: 1rem;
    line-height: 1rem;
    color: #84A559;
    font-size: 0.5rem;
    margin-bottom: 0.2rem;
}
.url {
    text-align: center;
    font-size: 22px;
    color: gold;
    margin-bottom: 1px;
}

.bet-money {
    font-size: 0.4rem;
    color: green;
}

.fanshui {
    font-size: 0.4rem;
    color: #90d934;
}

.revice {
    height: 30px;
    line-height: 30px;
    color: #312c2c;
    font-weight: 700;
    font-size: 0.35rem;
    width: 80%;
    margin: 0 auto;
    background-color: rgba(233, 214, 0, 0.947);
    text-align: center;
    border-radius: 5px;
    margin-top: 10px;
}

.revice2 {
    height: 30px;
    line-height: 30px;
    color: #fff;
    font-weight: 700;
    font-size: 0.35rem;
    width: 80%;
    margin: 0 auto;
    background-color: rgba(131, 130, 127, 0.947);
    text-align: center;
    border-radius: 5px;
    margin-top: 10px;
}

.title {
    height: 30px;
    line-height: 30px;
    font-size: 0.3rem;
    color: #84A559;
}

.Tips {
    width: 100%;
    height: auto;
    /* background: rgba(37, 82, 21, 0.343); */
    border-radius: 10px;
    padding: 0.34rem 0;
    padding-bottom: 15px;
    font-size: 0.35rem;
    color: #e5e5e5;
    line-height: 25px;
    padding-bottom: 0;

}

.items {
    width: 100%;
    height: auto;
    /* background: rgba(37, 82, 21, 0.343); */
    border: 1px solid #84A559;
    border-radius: 10px;
    padding: 0 0.34rem;
    padding-bottom: 15px;
    font-size: 0.35rem;
    color: #84A559;
    margin-bottom: 10px;

}

.big-wrap {
    min-height: 100vh;
    background: url("../images/vip/sbg.png");
}

.app-wrap {
    width: 95%;
    margin: 20px auto;
    padding: 10px;
    /* background: radial-gradient(#03cb50, transparent 86%); */
    margin-top: 20px;
    padding-bottom: 30px;
}
</style>